import { render, staticRenderFns } from "./Oops.vue?vue&type=template&id=284d673f&"
import script from "./Oops.vue?vue&type=script&lang=js&"
export * from "./Oops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports